export default __webpack_public_path__ + "static/media/standard-mode-icon.b734c571.png";